import { FormioRefreshValue } from '@formio/angular';
import { Component, AfterViewInit, ViewChild, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { PrismService } from '../../Prism.service';
import { ParserService } from '../../Services/parser.service';
import { RequestsService } from '../../Services/requests.service';
import { UserService } from '../../Services/userservice.service';
import { FacephiService } from '../../Services/facephi.service';

import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import Swal from 'sweetalert2';
import { Subject} from "rxjs";
import { MatCheckboxChange } from '@angular/material/checkbox';

import { options } from '../../forms/builder/options';
@Component({
  selector: 'app-editform',
  templateUrl: './editform.component.html',
  styleUrls: ['./editform.component.scss']
})
export class EditformComponent implements AfterViewInit,OnInit {
  @ViewChild('json', {static: true}) jsonElement?: ElementRef;
  @ViewChild('code', {static: true}) codeElement?: ElementRef;
  public form: Object;
  public options: any = options;
  public refreshForm: EventEmitter<FormioRefreshValue> = new EventEmitter();
  public rebuildEmitter: Subject<void> = new Subject<void>();
  constructor(
    public prism: PrismService,
    public parser:ParserService,
    public requests:RequestsService,
    private userService: UserService,
     private router: Router,
    private rutaActiva: ActivatedRoute,
    private facephiService: FacephiService
    ) {
    this.getLocale();
    this.form = {components: []};
  }

  
  hs_json:any={}
  hs_crear_editar:any={} //Utilizamos este si no se ha editado ningun componente del formulario y solo se desea cambiar el nombre
  hs_response={}
  forma={}
  name=""
  auxname="";
  correo_notify=""
  inlineMessage=""
  urlthankyoupage=""
  
  ocr:boolean = false;
  lifeValidation:boolean=false;
  documentValidation:boolean=false;
  onboarding:boolean=false;
  countryCode:string|any='GTM';
  countryDB:any={};
  token:string|any;

    //CredoLab
  analizarCredolab:boolean = false;
  public inputsForm:any[]=[];
  public startCredolab:string = 'submit';
  public stopCredolab:string = 'submit';

  super=false;
  logged=false;
  guid = "";
  hsform:any={}
  ngOnInit(): void {
    //obtener todos los paises
    this.GetCountrys()

    this.super=this.userService.is_super()
   // console.log(this.super)
    if (this.userService.isLoggedIn()) {
      this.logged = true
    }

    this.rutaActiva.params.subscribe(params => {
      this.name = params['nombre'];
      this.auxname = params['nombre'];
    });
   
    this.requests.getFormbyId(this.name).subscribe(
      res => {
       // console.log(JSON.parse(res[0].estructura_hs_crear));
        if (res) {
          this.form               = JSON.parse(res[0].estructura_angular);
          this.hsform             = JSON.parse(res[0].estructura_hs_resp)
          this.hs_crear_editar    = JSON.parse(res[0].estructura_hs_crear)
          this.guid               = this.hsform.guid;
          this.correo_notify      = this.hs_crear_editar.notifyRecipients;
          this.inlineMessage      = this.hs_crear_editar.inlineMessage;
          this.ocr                = this.hs_crear_editar.ocr || false;
          this.lifeValidation     = this.hs_crear_editar.lifeValidation || false;
          this.onboarding         = this.hs_crear_editar.onboarding || false;
          this.documentValidation = this.hs_crear_editar.documentValidation || false;
          this.countryCode        = this.hs_crear_editar.CountryOnboarding || 'GTM';
          this.urlthankyoupage    = res[0].url_thanks;
          this.getInputsForm(JSON.parse(res[0].estructura_angular)?.components);

          console.log("Structura ", this.hs_crear_editar);

          //Metadata de Credolab
          this.analizarCredolab   = this.hs_crear_editar.analizarCredolab || false;
          if( this.analizarCredolab ){
            this.startCredolab = ( this.hs_crear_editar.startCredolab ) ?  this.hs_crear_editar.startCredolab : 'submit';
          }

     //     console.log("dataForm ", this.countryCode)
          
          //console.log(this.form)
          this.desabilitarBoton(this.form['components']);
        }
      },
      err => {
        console.log(err);
        return err;
      }
    );

    //console.log(this.requests.getCookie('hubspotutk'))
    this.onPropagar();
    this.modePropagar();
    setTimeout(() => {
      this.changeForm();
    }, 500);
   
    
  }

  //obtener todos los paises
  GetCountrys(){
    this.userService.getTokenFacephi().subscribe( (res:any)=>{
      this.token = res.token || '';
      this.facephiService.getCountry(this.token).subscribe((res:any)=>{
        res.forEach( element => { this.countryDB[ element.Codigo ] = element.Nombre } );
      }, error => {
        console.log(error)
      });
    }, error => {
      console.log(error)
      this.token = '';
    })
  }

  //Agregar Analisis de comportamiento de credolab
  async changCheckboxCredolab(e:MatCheckboxChange){
    console.log("INPUTS FORM ", this.inputsForm);

      if( e.checked ){
        Swal.fire(
          'Análisis de metadatos (CredoLab)',
          'Se agregarán campos configurados en la HubDB al formulario, los cual siempre estarán ocultos, estos campos servirán para enviar la información extraída por Credolab a HubSPot.',
          'info'
        )
      }
    }

  //Agregar metodos de autenticacion de Facephi
  async changeCheckbox(e:MatCheckboxChange, type: string){

    if (e.checked) {
      Swal.fire({
        icon: 'warning',
        title: '¡Advertencia!',
        text: `Al escoger esta opción deberás hacer una validación back office en el caso de CRM, ya que Facephi no valida la integridad del documento adjunto.`,
        confirmButtonColor: '#001b71'
      }).then( async()=>{
  
        if( type.toUpperCase() == "ONBOARDING"){
          this.ocr = false;
          this.lifeValidation = false;
    
            const countrySe = await Swal.fire({
              title: '¿Código del país?',
              input: 'select',
              icon: 'question',
              inputOptions: this.countryDB,
              inputPlaceholder: 'Seleccione un país',
              showCancelButton: true,
              showConfirmButton: true,
            });
            this.countryCode = countrySe.value;
         //   console.log("VALOR SELECCIONADO ", this.countryCode );
  
            Swal.fire(
              'Onboarding',
              'Las imágenes que utilice el usuario para realizar las validaciones del onboarding, se guardarán en el envío del formulario.',
              'info'
            )
        }
      });
    }
    
    if( type.toUpperCase() != "ONBOARDING" && e.checked ){
      this.onboarding = false;
    }

  }


  changeForm(){
    this.rebuildEmitter.next(this.options);
    //let size = this.form['components'].length - 1;
   // console.log('En deshabilitar boton', this.form['components']);
    let eboton = document.getElementsByClassName("component-btn-group");
    //console.log(eboton);
    
    if(eboton != undefined){
   //   console.log('Opciones deshabilitadas');
      eboton[eboton.length - 1].setAttribute("style", "display:none;");
    }
  }

  desabilitarBoton(components:any){
   // console.log(components);
    if(components != undefined){
      for (const key of components) {
        if (key["type"] == 'button'){
       //   console.log('Boton desabilitado');
          key.disabled = true;
        }
      }
    }
  }

  getLocale(): void{
    this.options = options;
  }
  onPropagar() {
    this.userService.emitChange("Editar Formulario")
  }
  modePropagar() {
    this.userService.emitChange(2)
  }
  async onChange(event) {
    //console.log('Este evento->', event.form);
    this.jsonElement.nativeElement.innerHTML = '';
    this.jsonElement.nativeElement.appendChild(document.createTextNode(JSON.stringify(event.form, null, 4)));
    this.forma=event.form
    this.hs_json= await this.convert_json(event.form,this.name,"Enviar", this.correo_notify);

    this.refreshForm.emit({
      property: 'form',
      value: event.form
    });

    //Se desabilitan las opciones del boton
    let size;
    for (const key in event.form.components) {
      if(event.form.components[key].type == 'button'){
        size = key;
      }
    }


    let counter = 0;
    let pos = 0;
    for (const k of event.form.components) {
      counter++
      if(k.hasOwnProperty('columns')){
       // console.log('Tiene columns');
        for (const cm of k.columns) {
          for (const cp of cm.components) {
            counter++;
          }
        }
      }

      if(k.hasOwnProperty('components')){
        for (const cpm of k.components) {
          counter++;
          if(cpm.hasOwnProperty('columns')){
            for (const i of cpm.columns) {
              for (const iterator of i.components) {
                counter++;
              }
            }
          }
        }
      }
      
      if(k.type == 'button'){
        pos = counter
      }
    }

  //  console.log('Elementos: ' + counter);
   // console.log('Posicion boton: ' + pos);

    let eboton = document.getElementsByClassName("component-btn-group");

    if(eboton != undefined && eboton.length >0){
      if(eboton[pos-1]!=undefined){
        eboton[pos-1].setAttribute("style", "display:none;");
      }
    }

    //Ordena el formulario
    event.form.components.push(event.form.components.splice(size, 1)[0]);

    //Poner el modal de un tamaño fijo
    let modal = document.getElementsByClassName("formio-dialog-content");
    let card = document.getElementsByClassName("card-body tab-pane active");

    if(modal != undefined && modal.length >0){
      modal[0].setAttribute("style","height:800px;")
    }

    if(card != undefined && card.length >0){
      card[0].setAttribute("style","height:620px;")

    }

    //Se define un tamaño para el dropdown de las propiedades de contacto
    let modalkey = document.getElementsByClassName("form-group has-feedback formio-component formio-component-select formio-component-key");
    if(modalkey != undefined &&  modalkey.length > 0){
      modalkey[0].setAttribute("style", "height:400px;");
    }

    //Se oculta el dropdown de las opciones de storage del archivo
    let dropdownStorage = document.getElementsByClassName("form-group has-feedback formio-component formio-component-select formio-component-storage");
    if(dropdownStorage != undefined &&  dropdownStorage.length > 0){
      dropdownStorage[0].setAttribute("style", "display:none;");  
    }

    let checkdate = document.getElementsByClassName("form-check checkbox");
    if(checkdate != undefined && checkdate.length > 0){
      //console.log('Encontrado', checkdate);
      for (const iterator in checkdate) {
        if(checkdate[iterator]['innerText'] =="\n  \n    \n    Habilitar entrada de fecha\n    \n      \n    \n    \n    \n  \n"){
          checkdate[iterator].setAttribute("style", "display:none;");
        } 
      }
    }

  }

  ngAfterViewInit() {
    this.prism.init();
  }

  convert_json(json:any,nombre_form:string,submitText:string, email_notify:string) {
  //  this.inputsForm = json.components;
    this.inputsForm = [];
    this.getInputsForm(json.components);
    this.startCredolab = ( this.inputsForm[0]?.key ) ?  this.inputsForm[0]?.key : 'submit';
    return this.parser.angularToHs(json,nombre_form,submitText, email_notify);
  }


  getInputsForm(data:any):any{
    if(data.length <= 0 ) return;
    data.forEach((c:any)=>{
      if(c.type != 'columns' && c.type != 'container' && c.type){
        this.inputsForm.push(c);
      }else {
        const components = ( c.type == 'columns') ? c.columns : c.components;
        if( components && components.length > 0 ) this.getInputsForm(components);
      }
    })
  }

  onSubmit(event){
    //console.log(event)
  }


  validateEmail(email:string){
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if (regularExpression.test(String(email).toLowerCase())){
      return true
     } else {
      return false
     }
  }



  async sendtoHS(){ 

   /* console.log("CREDOLAB ", this.forma);
    return */

    if(this.name.trim() == ''){
      Swal.fire({
        icon: 'error',
        title:'Oops...',
        text: `El formulario no tiene un nombre asignado.`
      })
      return
    }
    //Validacion del correo de notificaciones
    if(this.correo_notify != ''){
      let correos = this.correo_notify.split(',')
      for(const correo of correos){
        if(!this.validateEmail(correo.trim())){
          Swal.fire({
            icon: 'error',
            title:'Oops...',
            text: `La dirección de correo ${correo} es invalida!`
          })
          return
        }  
      }
    }
    //Habilitamos el boton
    for (const e of this.form["components"]) {
      if(e.type == 'button'){
       // console.log('Boton habilitado');
        delete e.disabled
      } 
    }  

    if(Object.keys(this.forma).length > 0 ){
    //  console.log("forma", this.forma);
      for (const e of this.forma["components"]) {
      //  console.log("Boton habilitado");
        delete e.disabled;
      }  
    }

    //Validamos de que no exista un formulario con ese nombre y este deshabilitado
    let isDisabled = await this.requests.isDisabledForm(this.name.trim()).toPromise().then(res=>{
      return res
    }).
    catch(err => console.log(err))

    //Validacion si es el mismo nombre, o editaron el nombre del formulario
    if(this.name.trim() == this.auxname.trim()){
    //  console.log('Es el mismo nombre y esto trae hs_json', this.hs_json);
      this.hs_json.name=this.name.trim();
      this.hs_json.notifyRecipients = this.correo_notify;
      this.hs_json.inlineMessage = this.inlineMessage;
      this.hs_json.ocr = this.ocr;
      this.hs_json.lifeValidation = this.lifeValidation;
      this.hs_json.onboarding = this.onboarding;
      this.hs_json.documentValidation = this.documentValidation;
      this.hs_json.CountryOnboarding = this.countryCode;
      this.hs_json.analizarCredolab = this.analizarCredolab;
      if( this.analizarCredolab ){
        this.hs_json.startCredolab = this.startCredolab;
        this.hs_json.stopCredolab = this.stopCredolab;
      }

      //console.log("informacion hs",this.hs_json)

      if(this.hs_json.hasOwnProperty('formFieldGroups')){
        let isValid = this.isValidPropertyName(this.forma['components']);
        if(isValid > 0){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `Asigne las propiedades de contacto a los componentes para poder crear el formulario`,
          })
          return
        }

        await this.requests.hs_updateform(this.hs_json,this.guid).subscribe(
          res => {
          //    console.log(res);
              this.hs_response=res;
              this.requests.updateForm(this.name.trim(),this.hs_json,this.hs_response,this.forma,this.urlthankyoupage);
              // Redirige los formularios al editarse correctamente
              Swal.fire({
                icon:'success',
                title:'Edición de formulario',
                text: `Formulario ${this.name} editado exitosamente`,
                confirmButtonText: 'Ok'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigate(['ini']);
                } 
              })
          },
          err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Oops ocurrio un error al editar el formulario`
            })
            return err;
          }
        );

      }else{
        
        this.hs_crear_editar.name = this.name.trim();
        this.hs_crear_editar.notifyRecipients = this.correo_notify;
        this.hs_crear_editar.inlineMessage = this.inlineMessage;
        this.hs_crear_editar.ocr = this.ocr;
        this.hs_crear_editar.lifeValidation = this.lifeValidation;
        this.hs_crear_editar.onboarding = this.onboarding;
        this.hs_crear_editar.CountryOnboarding = this.countryCode;
        this.hs_crear_editar.documentValidation = this.documentValidation;
        this.hs_crear_editar.analizarCredolab = this.analizarCredolab;
        if( this.analizarCredolab ){
          this.hs_crear_editar.startCredolab = this.startCredolab;
          this.hs_crear_editar.stopCredolab = this.stopCredolab;
        }

       // console.log('2------>', this.hs_crear_editar);
        let isValid = this.isValidPropertyName(this.form['components']);
      
        if(isValid > 0){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `Asigne las propiedades de contacto a los componentes para poder crear el formulario`,
          })
          return
        }
        
        await this.requests.hs_updateform(this.hs_crear_editar, this.guid).subscribe(
          res=>{
         //   console.log(res);
            this.hs_response = res;
            this.requests.updateForm(this.name.trim(), this.hs_crear_editar, this.hs_response, this.form, this.urlthankyoupage);

            // Redirige los formularios al editarse correctamente
            Swal.fire({
              icon:'success',
              title:'Edición de formulario',
              text: `Formulario ${this.name} editado exitosamente`,
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['ini']);
              } 
            })
          },
          err => {
            console.log(err);

            if(err.status == 429){
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: err.error,
              })
              return
            }

            if(err.status == 401){
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Lo sentimos, la sesión ha expirado',
              })
            
              this.router.navigate(['login']);
              return 
            }

            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Hubo un error al editar el formulario`
            })
            return err;
          }
        )
        //this.router.navigate(['ini']);
      }
      
    }else{//Si es diferente es que le cambiaron el nombre al formulario
      //console.log('Es otro nombre');
      //Primero validamos de que el nuevo nombre no exista
      let isNameValid = await this.requests.isFormExists(this.name.trim()).toPromise().then(res =>{
        return res
      }).
      catch( err => console.log(err))
       
      if(!isNameValid.ok){
        Swal.fire({
          icon: 'error',
          title:'Oops...',
          text: `${isNameValid.message}`
        })
      }else {
        //console.log('El nombre del formulario es valido para cambiarlo');
        if(Object.keys(this.hs_json).length === 0 ){ //Se verifica si el objeto esta vacio
        //  console.log('No se edito nada del componente');
          //console.log('Esto trae el hs_crear', this.hs_crear_editar);
       //   console.log('3-------->', this.hs_crear_editar);
          
          this.hs_crear_editar.name = this.name.trim();
          this.hs_crear_editar.notifyRecipients = this.correo_notify;
          this.hs_crear_editar.inlineMessage = this.inlineMessage;
          this.urlthankyoupage = this.urlthankyoupage;
          this.hs_crear_editar.ocr = this.ocr;
          this.hs_crear_editar.onboarding = this.onboarding;
          this.hs_crear_editar.lifeValidation = this.lifeValidation;
          this.hs_crear_editar.documentValidation = this.documentValidation;
          this.hs_crear_editar.analizarCredolab = this.analizarCredolab;
          if( this.analizarCredolab ){
            this.hs_crear_editar.startCredolab = this.startCredolab;
            this.hs_crear_editar.stopCredolab = this.stopCredolab;
          }
          

          let isValid = this.isValidPropertyName(this.form['components']);
      
          if(isValid > 0){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Asigne las propiedades de contacto a los componentes para poder crear el formulario`,
            })
            return
          }
          await this.requests.hs_updateform(this.hs_crear_editar, this.guid).subscribe(
            res=>{
            //  console.log(res);
              this.hs_response = res;
              this.requests.updateFormWithName(this.name.trim(), this.auxname.trim(), this.hs_crear_editar, this.hs_response, this.form);
              // Redirige los formularios al editarse correctamente
              Swal.fire({
                icon:'success',
                title:'Edición de formulario',
                text: `Formulario ${this.name} editado exitosamente`,
                confirmButtonText: 'Ok'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigate(['ini']);
                } 
              })
            },
            err => {
              console.log(err);
              if(err.status == 429){
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: err.error,
                })
                return
              }
  
              if(err.status == 401){
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Lo sentimos, la sesión ha expirado',
                })
              
                return this.router.navigate(['login']);
              }
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Hubo un error en el servidor`
              })
              return err;
            } 
          )

        }else{

          this.hs_json.name = this.name.trim();
          this.hs_json.notifyRecipients = this.correo_notify;
          this.hs_json.inlineMessage = this.inlineMessage;
          this.urlthankyoupage = this.urlthankyoupage;
          this.hs_json.ocr = this.ocr;
          this.hs_json.onboarding = this.onboarding;
          this.hs_json.lifeValidation = this.lifeValidation;
          this.hs_json.documentValidation = this.documentValidation;
          this.hs_json.analizarCredolab = this.analizarCredolab;
          if( this.analizarCredolab ){
            this.hs_crear_editar.startCredolab = this.startCredolab;
            this.hs_crear_editar.stopCredolab = this.stopCredolab;
          }
         // console.log('4------->', this.hs_json);

          let isValid = this.isValidPropertyName(this.forma['components']);
      
          if(isValid > 0){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Asigne las propiedades de contacto a los componentes para poder crear el formulario`,
            })
            return
          }
          
          //Se hizo cambios en el formulario y en el nombre
          if(this.hs_json.hasOwnProperty('formFieldGroups')){
            await this.requests.hs_updateform(this.hs_json,this.guid).subscribe(
              res => {
              //    console.log(res);
                  this.hs_response=res;
                  this.requests.updateFormWithName(this.name.trim(),this.auxname.trim(),this.hs_json,this.hs_response,this.forma);
                  // Redirige los formularios al editarse correctamente
                  Swal.fire({
                    icon:'success',
                    title:'Edición de formulario',
                    text: `Formulario ${this.name} editado exitosamente`,
                    confirmButtonText: 'Ok'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['ini']);
                    } 
                  })
              },
              err => {
                console.log(err);

                if(err.status == 429){
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: err.error,
                  })
                  return
                }
    
                if(err.status == 401){
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Lo sentimos, la sesión ha expirado',
                  })
                
                  return this.router.navigate(['login']);
                }

                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: `Hubo un error al editar el formulario`
                })
                return err;
              }
            );
          }else{
            this.router.navigate(['ini']);
          }
        }  
      }
    }
  }


   //Este metodo valida que los componentes tengan asignadas las propiedades de contacto
  isValidPropertyName(components: any){
    //console.log('component',components);
    let contador = 0;
    components.map((element)=>{
      if(element.type != 'button' || element.type != 'htmlelement'){
        if(element.key === 'seleccione' || element.key.includes('seleccione')){
          contador++
        }
        
      }

      if(element.hasOwnProperty('columns')){
        //console.log('Validar si trae columnas');
        element.columns.map((e)=>{
          for(let comp in e.components){
            if(e.components[comp].hasOwnProperty('columns')){
              //console.log('Validad si trae columnas en columnas');
              e.components[comp].columns.map((x)=>{
                if(x.components[comp].key === 'seleccione' || x.components[comp].key.includes('seleccione')){
                  contador++
                }
              })
            }else if(e.components[comp].key === 'seleccione' || e.components[comp].key.includes('seleccione')){
              contador++
            }
          }
        }) 
      }

      //Verificar componentes en el contenedor
      if(element.type == 'container'){
        for (const c of element.components) {
          if(c.type === 'columns'){
            //console.log('------>', c);
            for (const cl of c.columns) {
              for(const cp of cl.components){
                if(cp.key === 'seleccione' || cp.key.includes('seleccione') ){
                  contador++
                }
              }
            }
          }
          if(c.key === 'seleccione'){
            contador++;
          }
        }
      }
    })

    return contador;

  }

  getusuario(){
   let str= localStorage.getItem('usuario');
   let usuario=JSON.parse(str);
   return usuario.id
  }

  public confirmar(){
    Swal.fire({
      title: '¿Esta seguro?',
      text: "Perderá su progreso en la creación del formulario",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, regresar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['ini']);
        
      }
    })
  }

  
}
